import axios from "axios";
import Config from "../../config/";
import moment from "moment";
import { encryptPayload } from "../../utils/encryption";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

const encodeQuery = value => encodeURIComponent(value == null ? "" : value);

export function encrypted(text) {
  return encryptPayload(text);
}

export function cekAuth() {
  return {
    headers: { Authorization: API_KEY + localStorage.getItem("token") }
  };
}

export function cekAuthIMIS() {
  return cekAuth();
}

export function cekAuthIpman() {
  return cekAuth();
}

export function cekAuthCctv() {
  return cekAuth();
}


export function loginIpMan() {
  return cekAuth();
}

export function authIpman(token) {
  return cekAuth();
}

export function fetchIMIS(call_sign) {
  const url = `${ROOT_URL}ipman/satellitevoyage/?callsign=${encodeQuery(call_sign)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchVesselIMIS(call_sign) {
  const url = `${ROOT_URL}ipman/satellitevoyagepanel/?callsign=${encodeQuery(call_sign)}`;
  const request = axios.get(url, cekAuth());

  return request;
}

export function fetchVoyageIMIS(CallLetter) {
  // const url = `https://ptmpisappprd01.pertamina.com/IMISSatelliteSynchronize/log/voyage?CallLetter=${CallLetter}`;
  // const url = `https://apps.pertamina.com/IMISSatelliteSynchronize/log/voyage?CallLetter=${CallLetter}`;
  const url = `${ROOT_URL}ipman/satellitevoyagepanel/?callsign=${encodeQuery(CallLetter)}`;

  const request = axios.get(url, cekAuth());

  return request;
}

export function fetchLoginIpman() {
  const url = `${ROOT_URL}ipman/clientservices/login/`;
  const request = axios.get(url, cekAuth());

  return request;
}

export function fetchVoyageNoIpman(token, callsign, date) {
  const url = `${ROOT_URL}ipman/clientservices/voyage-order/?callsign=${encodeQuery(callsign)}&date=${encodeQuery(date)}`;
  const request = axios.get(url, cekAuth());

  return request;
}

function pushloggingx(requests, description) {
  const url = `${ROOT_URL}logactivity/logactivity/`;
  let ippublic = "-";

  const fdata = new FormData();
  fdata.append("user_id", localStorage.getItem("id"));
  fdata.append("name", localStorage.getItem("name"));
  fdata.append("email", localStorage.getItem("email"));
  fdata.append("issuperuser", localStorage.getItem("is_superuser"));
  fdata.append("ipaddress", localStorage.getItem("ipaddress"));
  fdata.append("location", localStorage.getItem("location"));
  fdata.append("date_created", moment().format("YYYY-MM-DD HH:mm:ss"));
  fdata.append("os", "");
  fdata.append("activity", requests);
  fdata.append("description", description);


  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

function pushlogging(requests) {
  return true;
}

export function fetchDataipman(call_sign) {
  const url = `${ROOT_URL}ipman/mobile-voyage/?callsign=${encodeQuery(call_sign)}`;
  const request = axios.get(url, cekAuth());

  return request;
}

export function fetchtestPem(token) {
  const url = `${ROOT_URL}cctvactreport/remote/report/`;
  const request = axios.get(url, cekAuth());

  return request;
}

export function fetchShipnamecallsign() {
  const url = `${ROOT_URL}shipapirt/shipnamecallsign/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchShiprtbt(ship_id, startDate, endDate, source_api) {
  const url = `${ROOT_URL}shipapits/shiptrackbt/?ship_id=${encrypted(
    ship_id
  )}&startDate=${encrypted(startDate)}&endDate=${encrypted(
    endDate
  )}&source_api=${encrypted(source_api)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchFleetcombosearch(shipname) {

   
    const url = `${ROOT_URL}fleetrt/fleetcombosearch/?company_code=${encrypted(
      localStorage.getItem('company_code')
    )}&shipname=${encrypted(shipname)}`;
    const request = axios.get(url, cekAuth());
    pushlogging("get " + url);
    return request;
   
  
}



export function fetchIpmants(start_date, end_date, call_sign) {
  //const url = `${ROOT_URL}ipmants/ipmantsbydate/?date_created=${date_created}&call_sign=${call_sign}`;
  const url = `${ROOT_URL}ipmants/ipmantsbydate/?start_date=${encrypted(
    start_date
  )}&end_date=${encrypted(end_date)}&call_sign=${encrypted(call_sign)}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchVideoData(startDate, endDate, callsign, token) {
  const url = `${ROOT_URL}cctvactreport/remote/filter/?type=owner-image&callsign=${encodeQuery(callsign)}&start_date=${encodeQuery(startDate)}&end_date=${encodeQuery(endDate)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchVideoDataContract(startDate, endDate, callsign, token) {
  const url = `${ROOT_URL}cctvactreport/remote/filter/?type=contract&callsign=${encodeQuery(callsign)}&start_date=${encodeQuery(startDate)}&end_date=${encodeQuery(endDate)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchCCTVReport(token) {
  const url = `${ROOT_URL}cctvactreport/remote/report/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchCctvactreport() {
  const url = `${ROOT_URL}cctvactreport/cctvactreport/?limit=6000`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchCctvactreportbycomp() {
  const url = `${ROOT_URL}cctvactreport/cctvactreportbycomp/?company_code=${encrypted(localStorage.getItem("company_code")
  )}`;
  const request = axios.get(url, cekAuth());
  pushloggingx("get " + url, "Mangakses halaman CCTV Report");
  return request;
}

export function fetchSearchCctvactreport(callsign) {
  const url = `${ROOT_URL}cctvactreport/cctvactreport/?search=${callsign}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchLastUpdateCctv(shipname) {
  const url = `${ROOT_URL}cctvactreport/cctvactreport/?search=${shipname}`;
  const request = axios.get(url, cekAuth());
  pushloggingx("get " + url, "Mengakses halaman CCTV History");
  return request;
}

export function fetchApproachTotal(fraud_id) {
  const url = `${ROOT_URL}trackapproach/trackapproachtotal/?fraud_id=${encrypted(
    fraud_id
  )}`;
  const request = axios.get(url, cekAuth());
  //pushlogging("get "+url);
  return request;
}

export function fetchIpman(call_sign) {
  const url = `${ROOT_URL}ipman/ipman/?search=${call_sign}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchWeatherIndo() {
  const url = `${ROOT_URL}weather/weather/?limit=6000`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchWeather(lon, lat) {
  const url = `${ROOT_URL}weather/current/?lat=${encodeQuery(lat)}&lon=${encodeQuery(lon)}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchWeatherDate(lon, lat, datetime, dateend) {
  const url = `${ROOT_URL}weather/history/?lat=${encodeQuery(lat)}&lon=${encodeQuery(lon)}&start_date=${encodeQuery(datetime)}&end_date=${encodeQuery(dateend)}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchArrival(gid) {
  const url = `${ROOT_URL}shipfinder_tracker/marinetraffic/portcalls/?gid=${encodeQuery(gid)}&movetype=0`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchDeparture(gid) {
  const url = `${ROOT_URL}shipfinder_tracker/marinetraffic/portcalls/?gid=${encodeQuery(gid)}&movetype=1`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function delZonaTracking(id) {
  const url = `${ROOT_URL}drawsave/drawsave/${id}/`;
  const request = axios.delete(url, cekAuth());
  pushlogging("delete " + url);
  return request;
}

export function fetchPoiCat(id) {
  const url = `${ROOT_URL}poi_category/poicategory/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchLayers(id) {
  const url = `${ROOT_URL}gaspar/gaspar/`;
  const request = axios.get(url, cekAuth());
  // pushloggingx("get " + url, "Akses halaman Masterdata (Layers)");
  return request;
}

export function fetchEarthQuake() {
  const url = `${ROOT_URL}earthquake/earthquake/`;
  const request = axios.get(url);
  pushlogging("get " + url);
  return request;
}

export function fetchShipLine(id) {
  const url = `${ROOT_URL}shipfinder_tracker/shipfindertrack/?shipid=${encrypted(
    id
  )}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchIdleCategory(id) {
  const url = `${ROOT_URL}aisidle/aisidleshiptype/?category_id=${encrypted(
    id
  )}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchInactiveCategory(id, periode, source) {
  const url = `${ROOT_URL}inactive/inactivecatshiptype/?category_id=${encrypted(
    id
  )}&periode=${encrypted(periode)}&source=${encrypted(source)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchInactiveDaily() {
  const url = `${ROOT_URL}inactive/inactivedaily/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function delCatinactive(id) {
  const url = `${ROOT_URL}catinactive/catinactive/${id}/`;
  const request = axios.delete(url, cekAuth());
  pushlogging("delete " + url);
  return request;
}

export function delCatidleclose(id) {
  const url = `${ROOT_URL}cataisidle/cataisidle/${id}/`;
  const request = axios.delete(url, cekAuth());
  pushloggingx("delete " + url, "Menghapus kategori approach vessel");
  return request;
}

export function fetchZonaVolume(
  periode,
  sourcedata,
  usefor,
  startDate,
  endDate
) {
  const url = `${ROOT_URL}zonetracking/zonevolume/?user_id=${encrypted(
    localStorage.getItem("id")
  )}&periode=${encrypted(periode)}&sourcedata=${encrypted(
    sourcedata
  )}&usefor=${encrypted(usefor)}&startdate=${encrypted(
    startDate
  )}&enddate=${encrypted(endDate)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchZonaVolumeToday() {
  const url = `${ROOT_URL}zonetracking/zonevolumetoday/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchZoneShiptype(
  shiptype,
  periode,
  sourcedata,
  usefor,
  startDate,
  endDate
) {
  const url = `${ROOT_URL}zonetracking/zoneshiptype/?shiptype=${encrypted(
    shiptype
  )}&periode=${encrypted(periode)}&sourcedata=${encrypted(
    sourcedata
  )}&usefor=${encrypted(usefor)}&startdate=${encrypted(
    startDate
  )}&enddate=${encrypted(endDate)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchMontlyCat() {
  const url = `${ROOT_URL}zonetracking/zonemontlycat/?user_id=${encrypted(
    localStorage.getItem("id")
  )}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchMontly() {
  const url = `${ROOT_URL}zonetracking/zonemontly/?user_id=${encrypted(
    localStorage.getItem("id")
  )}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchMontlySum() {
  const url = `${ROOT_URL}zonetrackingsum/zonetrackingsum/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchShipZona_() {
  const url = `${ROOT_URL}zonetracking/zonetracking/?limit=10000`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchShipZona(periode, sourcedata, usefor, startDate, endDate) {
  const url = `${ROOT_URL}zonetracking/zonetrackingnew/?user_id=${encrypted(
    localStorage.getItem("id")
  )}&periode=${encrypted(periode)}&sourcedata=${encrypted(
    sourcedata
  )}&usefor=${encrypted(usefor)}&startdate=${encrypted(
    startDate
  )}&enddate=${encrypted(endDate)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchZoneTrackingLast(startDate, endDate, usefor) {
  const url = `${ROOT_URL}zonetracking/zonetrackinglast/?startdate=${encrypted(
    startDate
  )}&enddate=${encrypted(endDate)}&usefor=${encrypted(usefor)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchCatidleclose() {
  const url = `${ROOT_URL}cataisidle/cataisidle/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchAisidle(cat) {
  const url = `${ROOT_URL}aisidle/aisidle/?cat=${cat}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchAisidleDaily() {
  const url = `${ROOT_URL}aisidle/aisidledaily/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function pushCatIdleclose(data) {
  const url = `${ROOT_URL}cataisidle/cataisidle/`;

  const fdata = new FormData();
  fdata.append("name", data.name);
  fdata.append("description", data.description);
  fdata.append("timeidle", data.timeidle);
  fdata.append("distance", data.distance);
  fdata.append("deleted", 0);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("post " + url, "Menmbahkan kategori approach vessel");
  return request;
}

export function pushCatInactive(data) {
  const url = `${ROOT_URL}catinactive/catinactive/`;

  const fdata = new FormData();
  fdata.append("name", data.name);
  fdata.append("description", data.description);
  fdata.append("timeidle", data.timeidle);
  fdata.append("deleted", 0);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushlogging("post " + url);
  return request;
}

export function pushCatincompleteinfo(a, b, c) {
  const url = `${ROOT_URL}catincompleteinfo/catincompleteinfo/${a}/`;

  const fdata = new FormData();
  fdata.append("name", b);
  fdata.append("timeidle", "0");
  fdata.append("deleted", c);

  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("post " + url, "Menambahkan kategori Inactive");
  return request;
}

export function fetchInactive_(cat) {
  const url = `${ROOT_URL}inactive/inactive/?cat=${cat}&limit=5000`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchInactive(cat, periode, source) {
  const url = `${ROOT_URL}inactive/inactivedata/?category_id=${encrypted(
    cat
  )}&periode=${encrypted(periode)}&source=${encrypted(source)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchInactivePeriode(
  cat,
  source,
  startDate,
  endDate,
  limit,
  offset,
  orderby,
  sort,
  search
) {
  const url = `${ROOT_URL}inactive/inactivedataperiodex/?category_id=${encrypted(
    cat
  )}&source=${encrypted(source)}&startdate=${encrypted(
    startDate
  )}&enddate=${encrypted(endDate)}&limit=${encrypted(limit)}&offset=${encrypted(
    offset
  )}&search=${encrypted(search)}&orderby=${encrypted(
    orderby
  )}&ascdsc=${encrypted(sort)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchCatincompleteinfo() {
  const url = `${ROOT_URL}catincompleteinfo/catincompleteinfo/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchCatinactive() {
  const url = `${ROOT_URL}catinactive/catinactive/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchChangedestAll() {
  const url = `${ROOT_URL}changedest/changedestq/`;
  const fdata = new FormData();
  fdata.append("cek", "10");
  const request = axios.post(url, fdata, cekAuth());
  pushlogging("post " + url);
  return request;
}

export function fetchShipTrackerDel(id) {
  const url = `${ROOT_URL}shipfinder_tracker/shipfinder_tracker/${id}/`;
  const request = axios.delete(url, cekAuth());
  pushlogging("delete " + url);
  return request;
}

export function fetchShipTracker(id) {
  const url = `${ROOT_URL}shipfinder_tracker/shipfindertrackuser/?user_id=${encrypted(
    id
  )}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchShipTrack(id) {
  const url = `${ROOT_URL}shipapits/shiptrack/?ship_id=${encrypted(id)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchBasemapEsri() {
  const url = `${ROOT_URL}basemapesri/basemap/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchPortAll(search) {
  const url = `${ROOT_URL}cr_world_port/cr_world_port/?search=${search}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchZona() {
  const url = `${ROOT_URL}drawsave/drawsave/?limit=1000`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchZonabyUsefor() {
  const url = `${ROOT_URL}drawsave/drawsave/?search=general`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchUseForCat() {
  const url = `${ROOT_URL}drawsave/drawsaveusefor/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchZonabySearch(search) {
  const url = `${ROOT_URL}drawsave/drawsave/?search=${search}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchDistrict() {
  const url = `${ROOT_URL}province/provincelist/`;
  const fdata = new FormData();
  fdata.append("pr_id", "10");
  const request = axios.post(url, fdata, cekAuth());
  pushlogging("post " + url);
  return request;
}

export function fetchShipSearch(name) {
  const url = `${ROOT_URL}shipfinder_rt/shipfinder_rt/?search=${name}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchBasemapLegend(urlnya) {
  const url = urlnya;
  const request = axios.get(url);
  pushlogging("get " + url);
  return request;
}

export function fetchBasemapEsri_search(date) {
  let datenya = date.replace(/-/g, "");
  const url = `${ROOT_URL}basemapesri/basemap/?search=${encrypted(datenya)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchBasemapEsri_search_nolimit(date) {
  let datenya = date.replace(/-/g, "");
  const url = `${ROOT_URL}basemapesri/basemap/?search=${encrypted(
    datenya
  )}&limit=10000`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchBasemapEsri_search_year(tahun) {
  const fdata = new FormData();
  const url = `${ROOT_URL}basemapesri/bmdate/`;
  fdata.append("tahun", tahun);
  const request = axios.post(url, fdata, cekAuth());
  pushlogging("post " + url);
  return request;
}

export function fetchGetComKey() {
  const url = `https://api.shipdt.com/DataApiServer/getComKey`;
  const request = axios.get(url);
  pushlogging("get " + url);
  return request;
}

export function fetchVessel(
  topRight0,
  topRight1,
  topLeft0,
  topLeft1,
  bottomRight0,
  bottomRight1,
  bottomLeft0,
  bottomLeft1
) {
  const url = `${ROOT_URL}shipfinder_rt/shipfinderarea/`;
  const fdata = new FormData();
  fdata.append("topRight0", topRight0);
  fdata.append("topRight1", topRight1);
  fdata.append("topLeft0", topLeft0);
  fdata.append("topLeft1", topLeft1);
  fdata.append("bottomRight0", bottomRight0);
  fdata.append("bottomRight1", bottomRight1);
  fdata.append("bottomLeft0", bottomLeft0);
  fdata.append("bottomLeft1", bottomLeft1);
  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushlogging("post " + url);
  return request;
}

export function fetchVessel_old(zleft, zbottom, zright, ztop) {
  const a1 = zleft * 1000000;
  const a11 = a1.toString().split(".");
  const a11m = eval(parseFloat(a11[0])) * eval(-1);

  const a2 = zbottom * 1000000;
  const a22 = a2.toString().split(".");

  const a3 = zright * 1000000;
  const a33 = a3.toString().split(".");
  const a33m = eval(parseFloat(a33[0])) * eval(-1);

  const a4 = ztop * 1000000;
  const a44 = a4.toString().split(".");

  console.log(parseFloat(a22[0]));
  const url = `${ROOT_URL}shipfinder_rt/shipfinder_rt/?limit=500`;
  const request = axios.get(url);
  pushlogging("get " + url);
  return request;
}

export function fetchVesselV(zleft, zbottom, zright, ztop) {
  const a1 = zleft * 1000000;
  const a11 = a1.toString().split(".");
  const a11m = eval(parseFloat(a11[0])) * eval(-1);

  const a2 = zbottom * 1000000;
  const a22 = a2.toString().split(".");

  const a3 = zright * 1000000;
  const a33 = a3.toString().split(".");
  const a33m = eval(parseFloat(a33[0])) * eval(-1);

  const a4 = ztop * 1000000;
  const a44 = a4.toString().split(".");

  console.log(parseFloat(a22[0]));

  const url =
    `https://api.shipxy.com/apicall/GetAreaShip?v=2&` +
    `k=35fdad32ae4e4a33837ba85d9cb2fb64&enc=1&jsf=func&mode=0&scode=0&` +
    `xy=${parseFloat(a11[0])},${parseFloat(a44[0])}${a33m},${parseFloat(
      a44[0]
    )}` +
    `${a33m},${parseFloat(a22[0])}${a11m},${parseFloat(a22[0])}`;
  const request = axios.get(url);
  pushlogging("get " + url);
  return request;
}

export function fetchVesselVx(aa) {
  console.log(aa);

  const a1 = aa[0] * 1000000;
  const a11 = a1.toString().split(".");

  const a2 = aa[1] * 1000000;
  const a22 = a2.toString().split(".");

  const a3 = aa[2] * 1000000;
  const a33 = a3.toString().split(".");

  const a4 = aa[3] * 1000000;
  const a44 = a4.toString().split(".");

  console.log(parseFloat(a22[0]));

  const url =
    `https://api.shipxy.com/apicall/GetAreaShip?v=2&` +
    `k=35fdad32ae4e4a33837ba85d9cb2fb64&enc=1&jsf=func&mode=0&scode=0&` +
    `xy=-10282110,${parseFloat(a22[0])}-${parseFloat(a11[0])},` +
    `${parseFloat(a44[0])}-${parseFloat(a33[0])},-11000000`;
  const request = axios.get(url);
  pushlogging("get " + url);
  return request;
}

export function fetchDate(tahun) {
  const fdata = new FormData();
  const url = `${ROOT_URL}basemapesri/bmdate/`;
  fdata.append("tahun", tahun);
  const request = axios.post(url, fdata, cekAuth());
  pushlogging("post " + url);
  return request;
}

export function fetchPort() {
  const url = `${ROOT_URL}portpoi/portpoi/`;
  const request = axios.get(url);
  pushlogging("get " + url);
  return request;
}

export function fetchPorts() {
  const url = `${ROOT_URL}cr_world_port/cr_world_port/?limit=10000`;
  const request = axios.get(url);
  pushlogging("get " + url);
  return request;
}

export function pushFavorite(data) {
  const url = `${ROOT_URL}shipfinder_tracker/shipfinder_tracker/`;
  const fdata = new FormData();
  fdata.append("ppid", data.shipid);
  fdata.append("shipid", data.shipid);
  fdata.append("name", data.name);
  fdata.append("mmsi", 0);
  fdata.append("begin", 0);
  fdata.append("end", 0);
  fdata.append("status", 0);
  fdata.append("notall", 0);
  fdata.append("datatype", 0);
  fdata.append("utc", 0);
  fdata.append("latitude", data.latitude);
  fdata.append("longitude", data.longitude);
  fdata.append("navistat", 0);
  fdata.append("sog", 0);
  fdata.append("cog", 0);
  fdata.append("user_id", localStorage.getItem("id"));

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushlogging("post " + url);
  return request;
}

export function pushDrawData(name, data, dataall) {
  if (data === null) {
    data = "-";
  }

  const url = `${ROOT_URL}drawsave/drawsave/`;
  const fdata = new FormData();
  fdata.append("name", name);
  fdata.append("geom", data);
  fdata.append("geomall", dataall);
  fdata.append("usefor", "general");
  fdata.append("user_id", localStorage.getItem("id"));
  fdata.append("dateCreated", moment().format("YYYY-MM-DD HH:mm:ss"));
  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushlogging("post " + url);
  return request;
}

export function fetchPOI() {
  const url = `${ROOT_URL}poi/poi/?limit=10000`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchPOI2() {
  const url = `${ROOT_URL}poi/poi/?limit=10`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchPOIPort() {
  const url = `${ROOT_URL}poi/poi/?search=port`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchPOIOffice() {
  const url = `${ROOT_URL}poi/poi/?search=office`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchPoiSearch(search) {
  const url = `${ROOT_URL}poi/poi/?search=${search}&limit=10`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchVesselnew() {
  const url = `${ROOT_URL}shipapirt/shipapirt/?limit=6000`;
  const request = axios.get(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushlogging("get " + url);
  return request;
}

export function fetchVesselnew2() {
  const url = `${ROOT_URL}shipapirt/shipapirt/?limit=10`;
  const request = axios.get(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushlogging("get " + url);
  return request;
}

export function fetchVesselPtm() {
  const url = `${ROOT_URL}shipapirt/shipapirtptmn/?user_id=${encrypted(
    localStorage.getItem("id")
  )}&userlevel=${encrypted(localStorage.getItem("userlevel"))}`;
  const request = axios.get(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushlogging("get " + url);
  return request;
}

export function fetchVesselPtmSource(source) {
  const url = `${ROOT_URL}shipapirt/shipapirtptmnnew/?sourceAis=${encrypted(
    source
  )}&user_id=${encrypted(localStorage.getItem("id"))}&userlevel=${encrypted(
    localStorage.getItem("userlevel")
  )}`;
  const request = axios.get(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushlogging("get " + url);
  return request;
}

export function fetchVesselPtmSourcex(source) {
  const url = `${ROOT_URL}shipapirt/shipapirtptmnnewx/?sourceAis=${encrypted(
    source
  )}&user_id=${encrypted(localStorage.getItem("id"))}&userlevel=${encrypted(
    localStorage.getItem("userlevel")
  )}&company_code=${encrypted(localStorage.getItem("company_code"))}`;
  const request = axios.get(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushlogging("get " + url);
  return request;
}

export function fetchVesselPtmSourcexy(source) {
  const url = `${ROOT_URL}shipapirt/shipapirtptmnnewxy/?sourceAis=${encrypted(
    source
  )}&user_id=${encrypted(localStorage.getItem("id"))}&userlevel=${encrypted(
    localStorage.getItem("userlevel")
  )}&company_code=${encrypted(localStorage.getItem("company_code"))}`;
  const request = axios.get(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("get " + url, "Akses halaman Map");
  return request;
}

export function fetchVesselPtmSourcerev(source) {
  const url = `${ROOT_URL}shipapirt/shipapirtptmnnewrev/?sourceAis=${encrypted(
    source
  )}&user_id=${encrypted(localStorage.getItem("id"))}&userlevel=${encrypted(
    localStorage.getItem("userlevel")
  )}`;
  const request = axios.get(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("get " + url, "Akses Halaman Monitoring");
  return request;
}

export function fetchFleetPtmSource(source) {
  const url = `${ROOT_URL}fleetrt/fleetrtptmnnew/?sourceAis=${encrypted(
    source
  )}&user_id=${encrypted(localStorage.getItem("id"))}&userlevel=${encrypted(
    localStorage.getItem("userlevel")
  )}`;
  const request = axios.get(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushlogging("get " + url);
  return request;
}

export function fetchVesselSearch(name) {
  const url = `${ROOT_URL}shipapirt/shipapirt/?search=${name}&limit=10`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchPtmFleetSearch(name) {
  const url = `${ROOT_URL}fleetrt/fleetrt/?search=${name}&limit=10`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchPtmGpsapirtSearch(name) {
  const url = `${ROOT_URL}gpsapirt/gpsapirt/?search=${name}&limit=10`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchPtmGpsapirtSearchStatus(status) {
  const url = `${ROOT_URL}gpsapirt/gpsapirt/?search=${status}&limit=1000`;
  const request = axios.get(url, cekAuth());
  pushloggingx("get " + url, "Mengakses halaman Reporting");
  return request;
}

export function fetchPtmGpsapirt() {
  const url = `${ROOT_URL}gpsapirt/gpsapirt/?limit=1000`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchVesselDetailMT(mmsi) {
  const url = `${ROOT_URL}shipfinder_tracker/marinetraffic/vessel-detail/?mmsi=${encodeQuery(mmsi)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchVesselbyship_id(ship_id) {
  const url = `${ROOT_URL}vessellist/vessellist/?search=${ship_id}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchCatshiptype() {
  const url = `${ROOT_URL}catshiptype/catshiptype/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchTrackJump(catid, periode) {
  const url = `${ROOT_URL}trackjump/trackjumpnew/?catid=${encrypted(
    catid
  )}&periode=${encrypted(periode)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchCatJumping() {
  const url = `${ROOT_URL}catjumping/catjumping/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function pushCatJumping(data) {
  const url = `${ROOT_URL}catjumping/catjumping/`;

  const fdata = new FormData();
  fdata.append("name", data.name);
  fdata.append("description", data.description);
  fdata.append("operation", data.operation);
  fdata.append("jumping", parseFloat(data.jumping) * 1609);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("post " + url, "Menambahkan kategori jumping vessel");
  return request;
}

export function delCatJumping(id) {
  const url = `${ROOT_URL}catjumping/catjumping/${id}/`;
  const request = axios.delete(url, cekAuth());
  pushloggingx("delete " + url, "Menghapus kategori jumping");
  return request;
}

export function fetchTrackJumpPeriode(
  startDate,
  endDate,
  limit,
  offset,
  catid,
  orderby,
  sort,
  search
) {
  const url = `${ROOT_URL}trackjump/trackjumpperiodesx/?catid=${encrypted(
    catid
  )}&startdate=${encrypted(startDate)}&enddate=${encrypted(
    endDate
  )}&limit=${encrypted(limit)}&offset=${encrypted(offset)}&search=${encrypted(
    search
  )}&orderby=${encrypted(orderby)}&ascdsc=${encrypted(sort)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchTrackDraugh() {
  const url = `${ROOT_URL}trackdraugh/trackdraugh/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchDraugh() {
  const url = `${ROOT_URL}draught/draught/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchDraughPeriode(periode) {
  const url = `${ROOT_URL}draught/draughtdata/?periode=${encrypted(periode)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchCatDraugh() {
  const url = `${ROOT_URL}catdraugh/catdraugh/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function pushCatDraugh(data) {
  const url = `${ROOT_URL}catdraugh/catdraugh/`;

  const fdata = new FormData();
  fdata.append("name", data.name);
  fdata.append("description", data.description);
  fdata.append("operation", data.operation);
  fdata.append("draugh", data.draugh);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("post " + url, "Menambahkan kategori draught");
  return request;
}

export function delCatDraugh(id) {
  const url = `${ROOT_URL}catdraugh/catdraugh/${id}/`;
  const request = axios.delete(url, cekAuth());
  pushloggingx("delete " + url, "Menghapus kategori draught");
  return request;
}

export function fetchTrackSpeed(catid, periode) {
  const url = `${ROOT_URL}trackspeed/trackspeednew/?catid=${encrypted(
    catid
  )}&periode=${encrypted(periode)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchCatSpeed() {
  const url = `${ROOT_URL}catspeed/catspeed/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchSpeedAlertPeriode(
  startDate,
  endDate,
  limit,
  offset,
  orderby,
  sort,
  search,
  catid
) {
  const url = `${ROOT_URL}trackspeed/trackspeedperiodex/?startdate=${encrypted(
    startDate
  )}&enddate=${encrypted(endDate)}&limit=${encrypted(limit)}&offset=${encrypted(
    offset
  )}&search=${encrypted(search)}&orderby=${encrypted(
    orderby
  )}&ascdsc=${encrypted(sort)}&catid=${encrypted(catid)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchTrackFraud() {
  const url = `${ROOT_URL}trackapproach/trackapproachnew/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchTrackFraudPeriode(
  startDate,
  endDate,
  limit,
  offset,
  orderby,
  sort,
  search
) {
  const url = `${ROOT_URL}trackfraudts/trackfraudtsperiodex/?startdate=${encrypted(
    startDate
  )}&enddate=${encrypted(endDate)}&limit=${encrypted(limit)}&offset=${encrypted(
    offset
  )}&search=${encrypted(search)}&orderby=${encrypted(
    orderby
  )}&ascdsc=${encrypted(sort)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchTrackFraudPeriodeToday() {
  const url = `${ROOT_URL}trackfraud/trackfrauddaily/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchTrackDraughtPeriode(
  startDate,
  endDate,
  limit,
  offset,
  orderby,
  sort,
  search
) {
  const url = `${ROOT_URL}draught/draughtdataperiodex/?startdate=${encrypted(
    startDate
  )}&enddate=${encrypted(endDate)}&limit=${encrypted(limit)}&offset=${encrypted(
    offset
  )}&search=${encrypted(search)}&orderby=${encrypted(
    orderby
  )}&ascdsc=${encrypted(sort)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchTrackFraudApproachx(fraudid) {
  const url = `${ROOT_URL}trackapproach/trackapproach/?search=${fraudid}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchTrackFraudApproach(fraudid) {
  const url = `${ROOT_URL}trackapproach/trackapproachbyfraudid/?fraud_id=${encrypted(
    fraudid
  )}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function pushCatSpeed(data) {
  const url = `${ROOT_URL}catspeed/catspeed/`;

  const fdata = new FormData();
  fdata.append("name", data.name);
  fdata.append("description", data.description);
  fdata.append("operation", data.operation);
  fdata.append("speed", data.speed);
  fdata.append("vessel_category", data.selectedCategoryVesselCat);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("post " + url, "Menambahkan kategori Speed");
  return request;
}

export function delCatSpeed(id) {
  const url = `${ROOT_URL}catspeed/catspeed/${id}/`;
  const request = axios.delete(url, cekAuth());
  pushlogging("delete " + url, "Menghapus kategori speed");
  return request;
}
